import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FamilyMemberFormService } from 'src/app/_services/family-member-form.service';
import { ProposalService } from 'src/app/_services/proposal.service';
import { UserAuthService } from 'src/app/_services/user-auth.service';

import { BaseVehicleService } from '../../vehicle/base-vehicle.service';
import { BUSINESS_INSURANCE_BASE } from '../company-insurance-constants';
import { BUSINESS_VEHICLE_INSURANCE_BASE, BUSINESS_VEHICLE_STEPS } from './constants';

@Injectable({
  providedIn: 'root',
})
export abstract class BusinessVehicleService extends BaseVehicleService {
  constructor(
    route: ActivatedRoute,
    authService: UserAuthService,
    proposalService: ProposalService,
    familyMemberService: FamilyMemberFormService,
    private readonly router: Router,
  ) {
    super(route, authService, proposalService, familyMemberService);
    this.router.navigate(
      [
        '/',
        BUSINESS_INSURANCE_BASE,
        BUSINESS_VEHICLE_INSURANCE_BASE,
        BUSINESS_VEHICLE_STEPS.MAIN_FORM.url,
      ],
      {
        replaceUrl: true,
      },
    );
    this.handleQueryParams();

    this.navigationChangeSubscription = this.router.events.subscribe((val) => {
      if (!(val instanceof NavigationEnd)) return;
      if (
        val.urlAfterRedirects.includes(BUSINESS_INSURANCE_BASE) &&
        val.urlAfterRedirects.includes(BUSINESS_VEHICLE_INSURANCE_BASE) &&
        val.urlAfterRedirects.includes(BUSINESS_VEHICLE_STEPS.MAIN_FORM.url) &&
        !this.initDone
      )
        this.handleQueryParams();
    });
  }
}
